import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result } from '@digibricks/domains';
import { QuestionType } from '../question-type';
import { File } from '../file';
import { AudioFile } from '../audio-file';
import { Score } from '../score';
import MarkdownIt from 'markdown-it';
export var QuestionRelease = /*#__PURE__*/function (_Entity) {
  _inherits(QuestionRelease, _Entity);

  var _super = _createSuper(QuestionRelease);

  function QuestionRelease() {
    _classCallCheck(this, QuestionRelease);

    return _super.apply(this, arguments);
  }

  _createClass(QuestionRelease, [{
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "files",
    get: function get() {
      return this.props.files;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "sectionId",
    get: function get() {
      return this.props.sectionId;
    }
  }, {
    key: "formReleaseId",
    get: function get() {
      return this.props.formReleaseId;
    }
  }, {
    key: "score",
    get: function get() {
      return this.props.score.value;
    }
  }, {
    key: "scoreV2",
    get: function get() {
      return this.props.score;
    }
  }, {
    key: "explanation",
    get: function get() {
      return this.props.explanation;
    }
  }, {
    key: "index",
    get: function get() {
      return this.props.index;
    }
  }, {
    key: "nextIndex",
    get: function get() {
      return this.props.nextIndex;
    }
  }, {
    key: "audioFile",
    get: function get() {
      return this.props.audioFile;
    }
  }, {
    key: "answers",
    get: function get() {
      return this.props.answers;
    }
  }, {
    key: "previousQuestionId",
    get: function get() {
      return this.props.previousQuestionId;
    }
  }, {
    key: "titleIndex",
    get: function get() {
      return this.props.nextIndex && this.props.nextIndex - this.props.index > 1 ? "".concat(this.props.index, " - ").concat(this.props.nextIndex - 1) : this.props.index.toString();
    }
  }, {
    key: "isEssayQuestion",
    value: function isEssayQuestion() {
      return this.type === QuestionType.Essay;
    }
  }, {
    key: "isFillInBlankQuestion",
    value: function isFillInBlankQuestion() {
      return this.type === QuestionType.FillInBlank;
    }
  }, {
    key: "renderMarkdown",
    value: function renderMarkdown(content) {
      var md = new MarkdownIt();
      return Result.ok(md.render(content));
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      var _this$audioFile;

      return _objectSpread(_objectSpread({}, this.props), {}, {
        description: this.renderMarkdown(this.props.description),
        files: this.props.files.map(function (file) {
          return file.toJsonObject();
        }),
        score: this.props.score.toJsonObject(),
        audioFile: (_this$audioFile = this.audioFile) === null || _this$audioFile === void 0 ? void 0 : _this$audioFile.toJsonObject()
      });
    }
  }, {
    key: "cloneExtendedProps",
    value: function cloneExtendedProps(question, newQuestionProps, hasCorrectAnswer, showExplanation) {
      return Result.ok(question);
    }
  }, {
    key: "clone",
    value: function clone(hasCorrectAnswer, showExplanation) {
      var newProps = {
        id: this.id.toString(),
        description: this.props.description,
        sectionId: this.props.sectionId,
        formReleaseId: this.props.formReleaseId,
        score: this.props.score,
        type: this.props.type,
        files: _toConsumableArray(this.props.files),
        index: this.props.index,
        audioFile: this.props.audioFile,
        nextIndex: this.props.nextIndex,
        explanation: this.props.explanation || null
      };
      return this.cloneExtendedProps(this, newProps, hasCorrectAnswer, showExplanation).getValue();
    }
  }, {
    key: "convertToQuestionProps",
    value: function convertToQuestionProps() {
      var baseProps = _objectSpread(_objectSpread({}, this.props), {}, {
        formId: '',
        score: this.props.score
      });

      return baseProps;
    }
  }, {
    key: "addIndex",
    value: function addIndex(index) {
      this.props.index = index;
      return Result.ok();
    }
  }, {
    key: "addNextIndex",
    value: function addNextIndex(index) {
      this.props.nextIndex = index;
      return Result.ok();
    }
  }], [{
    key: "createBaseProps",
    value: function createBaseProps(props) {
      var _props$files;

      var resultOrError = this.validate(props);

      if (resultOrError.isFailure) {
        var _resultOrError$error;

        return Result.fail((_resultOrError$error = resultOrError.error) !== null && _resultOrError$error !== void 0 ? _resultOrError$error : 'Error');
      }

      var defaultProps = _objectSpread(_objectSpread({}, props), {}, {
        files: (_props$files = props.files) !== null && _props$files !== void 0 ? _props$files : []
      });

      return Result.ok(defaultProps);
    }
  }, {
    key: "validate",
    value: function validate(props) {
      var guardResult = Guard.againstNullOrUndefined(props, 'Question Props');

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Error');
      }

      var guardCollections = [{
        argument: props.sectionId,
        argumentName: 'Section Id'
      }, {
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.description,
        argumentName: 'Description'
      }, {
        argument: props.formReleaseId,
        argumentName: 'Form Release Id'
      }, {
        argument: props.score,
        argumentName: 'Score'
      }, {
        argument: props.type,
        argumentName: 'Question Release Type'
      }];
      var guardCollectionResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardCollectionResult.succeeded) {
        return Result.fail(guardCollectionResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "fromJsonBase",
    value: function fromJsonBase(data) {
      var files = data.files,
          score = data.score,
          audioFile = data.audioFile;
      var mappedFiles = [];

      var _iterator = _createForOfIteratorHelper(files),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var file = _step.value;
          var fileOrError = File.fromJson(file);

          if (fileOrError.isFailure) {
            return Result.fail(fileOrError.error);
          }

          mappedFiles.push(fileOrError.getValue());
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return this.createBaseProps(_objectSpread(_objectSpread({}, data), {}, {
        files: mappedFiles,
        score: Score.create(score).getValue(),
        audioFile: audioFile ? AudioFile.fromJson(audioFile).getValue() : undefined
      }));
    }
  }]);

  return QuestionRelease;
}(Entity);